export default __webpack_public_path__ + "static/hero-4-7fa6fbe8e75f9e8ddaaa70a5ef77a005.webp";